import { render } from "./ReceivedCfdis.vue?vue&type=template&id=338ec7cd&scoped=true"
import script from "./ReceivedCfdis.vue?vue&type=script&lang=js"
export * from "./ReceivedCfdis.vue?vue&type=script&lang=js"

import "./ReceivedCfdis.vue?vue&type=style&index=0&id=338ec7cd&lang=css"
import "./ReceivedCfdis.vue?vue&type=style&index=1&id=338ec7cd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-338ec7cd"]])

export default __exports__